import { axios as request } from './apiAdmin';
import { exportFile } from '../requestDownloadFile';

export default {
    login: data => {
        return request.post('auth/login', data);
    },
    signOut: data => {
        return request.post('auth/logout', data);
    },
    getPublisherList: data => {
        return request.get('publisher/list', {params: data});
    },
    publisherAssociate: data => {
        return request.put('publisher/associate', data);
    },
    modifyPublisher: data => {
        return request.put('publisher/note', data);
    },
    reviewPublisher: data => {
        return request.put('publisher/review', data);
    },
    getPublisherCount: () => {
        return request.get('publisher/count');
    },
    // 获取商家近 30 天的广告活动聚合报表
    getSellerReport: data => {
        return request.get('seller/report/campaign-agg-30d', { params: data });
    },
    getSellerList: () => {
        return request.get('seller/list');
    },
    // 管理员
    getUserList: data => {
        return request.get('users', { params: data });
    },
    addUser: data => {
        return request.post('users', data);
    },
    enableUser: data => {
        return request.post(`users/${data.id}/enable`);
    },
    updateUser: data => {
        return request.patch(`users/${data.id}`, data);
    },
    disableUser: data => {
        return request.post(`users/${data.id}/disable`);
    },
    getCommissionReports: data => {
        return request.get('commission/reports', { params: data }).then(res=>res.data);
    },
    getCommissionReportsAgg: data => {
        return request.get('commission/reports/agg', { params: data }).then(res=>res.data);
    },
    searchPublisher: data => {
        return request.get('publisher/search', { params: data }).then(res=>res.data);
    },
    searchSeller: data => {
        return request.get('seller/search', { params: data }).then(res=>res.data);
    },
    searchBrand: data => {
        return request.get('brand/search', { params: data }).then(res=>res.data);
    },
    searchAsin: data => {
        return request.get(`seller/searchAsin?asin=${data.asin}`, data ).then(res=>res.data);
    },
    changePublisherNote: data => {
        return request.patch(`commission/reports/note/${data.id}`, data).then(res=>res.data);
    },
    commissionReportsExport:data => {
        return exportFile(`commission/reports/export`,  data.qs, data.fileName, data.platform);
    },
    // 威龙，审核 publisher 的银行相关信息: http://118.31.23.117:8077/doc.html#/%E8%BF%90%E8%90%A5%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%8F%91%E5%B8%83%E8%80%85%E4%BF%A1%E6%81%AF/bankReviewUsingPUT
    reviewPublisherBankStatus: data => {
        return request.put(`publisher/bank/review`, data);
    },
    exportPublisher: data => {
        return exportFile(`publisher/export`, data.qs, data.fileName, data.platform);
    },
    exportSeller: data => {
        return exportFile(`finance/seller/billings/details/all-items/export`, data.qs, data.fileName, data.platform);
    },
    associateCommissionReportsAgg: data => {
        return request.get('associate/commission/reports/agg', { params: data }).then(res=>res.data);
    },
    associateCommissionReportsPerformance: data => {
        return request.get('associate/commission/reports/performance', { params: data }).then(res=>res.data);
    },
    associateCommissionReportsPerformanceExport: data => {
        return exportFile(`associate/commission/reports/performance/export`, data.qs, data.fileName, data.platform);
    },
    // Creator Connections performance
    commissionReportsAggCc: data => {
        return request.get('cc/bonus/reports/agg', { params: data }).then(res=>res.data);
    },
    commissionReportsPerformanceCc: data => {
        return request.get('cc/bonus/reports/performance', { params: data }).then(res=>res.data);
    },
    commissionReportsPerformanceDailyMetricCc: data => {
        return request.get('cc/bonus/reports/performance/daily-metric', { params: data }).then(res=>res.data);
    },
    commissionReportsPerformanceExportCc: data => {
        return exportFile(`cc/bonus/reports/performance/export`, data.qs, data.fileName, data.platform);
    },
    commissionReportsAggPerformance: data => {
        return request.get('commission/reports/agg', { params: data,isV2: true }).then(res=>res.data);
    },
    associateCommissionReportsAggPerformance: data => {
        return request.get('associate/commission/reports/agg', { params: data }).then(res=>res.data);
    },
    commissionReportsPerformance: data => {
        return request.get('commission/reports/performance', { params: data,isV2: true }).then(res=>res.data);
    },
    commissionReportsPerformanceDailyMetric: data => {
        return request.get('commission/reports/performance/daily-metric', { params: data ,isV2: true}).then(res=>res.data);
    },
    commissionReportsPerformanceExport: data => {
        return exportFile(`commission/reports/performance/export`, data.qs, data.fileName, data.platform);
    },
    commissionReportsProduct: data => {
        return request.get('commission/reports/product', { params: data,isV2: true }).then(res=>res.data);
    },
    commissionReportsProductAssociate: data => {
        return request.get('associate/commission/reports/product', { params: data }).then(res=>res.data);
    },
    commissionReportsProductMetric: data => {
        return request.get('commission/reports/product/metric', { params: data,isV2: true }).then(res=>res.data);
    },
    getAssociateCommissionReportsProductMetric: data => {
        return request.get('associate/commission/reports/product/metric', { params: data }).then(res=>res.data);
    },
    commissionReportsProductDailyMetric: data => {
        return request.get('commission/reports/product/daily-metric', { params: data ,isV2: true}).then(res=>res);
    },
    associateCommissionReportsProductDailyMetric: data => {
        return request.get('associate/commission/reports/product/daily-metric', { params: data }).then(res=>res);
    },
    commissionReportsProductExport: data => {
        return exportFile(`commission/reports/product/export`, data.qs, data.fileName, data.platform);
    },
    associateCommissionReportsProductExport: data => {
        return exportFile(`associate/commission/reports/product/export`, data.qs, data.fileName, data.platform);
    },
    // Creator Connections product
    commissionReportsProductCc: data => {
        return request.get('cc/bonus/reports/product', { params: data }).then(res=>res.data);
    },
    commissionReportsProductMetricCc: data => {
        return request.get('cc/bonus/reports/product/metric', { params: data }).then(res=>res.data);
    },
    commissionReportsProductDailyMetricCc: data => {
        return request.get('cc/bonus/reports/product/daily-metric', { params: data }).then(res=>res);
    },
    commissionReportsProductExportCc: data => {
        return exportFile(`cc/bonus/reports/product/export`, data.qs, data.fileName, data.platform);
    },
    commissionReportsBrand: data => {
        return request.get('commission/reports/brand', { params: data,isV2: true }).then(res=>res.data);
    },
    commissionReportsBrandAssociate: data => {
        return request.get('associate/commission/reports/brand', { params: data }).then(res=>res);
    },
    commissionReportsBrandMetric: data => {
        return request.get('commission/reports/brand/metric', { params: data,isV2: true }).then(res=>res.data);
    },
    associateCommissionReportsBrandMetric: data => {
        return request.get('associate/commission/reports/brand/metric', { params: data }).then(res=>res);
    },
    commissionReportsBrandDailyMetric: data => {
        return request.get('commission/reports/brand/daily-metric', { params: data ,isV2: true}).then(res=>res);
    },
    associateCommissionReportsBrandDailyMetric: data => {
        return request.get('associate/commission/reports/brand/daily-metric', { params: data }).then(res=>res);
    },
    
    commissionReportsBrandExport: data => {
        return exportFile(`commission/reports/brand/export`, data.qs, data.fileName, data.platform);
    },
    associateCommissionReportsBrandExport: data => {
        return exportFile(`associate/commission/reports/brand/export`, data.qs, data.fileName, data.platform);
    },
    // Creator Connections brand
    commissionReportsBrandCc: data => {
        return request.get('cc/bonus/reports/brand', { params: data }).then(res=>res.data);
    },
    commissionReportsBrandMetricCc: data => {
        return request.get('cc/bonus/reports/brand/metric', { params: data }).then(res=>res.data);
    },
    commissionReportsBrandDailyMetricCc: data => {
        return request.get('cc/bonus/reports/brand/daily-metric', { params: data }).then(res=>res);
    },
    commissionReportsBrandExportCc: data => {
        return exportFile(`cc/bonus/reports/brand/export`, data.qs, data.fileName, data.platform);
    },
    commissionReportsPublisher: data => {
        return request.get('commission/reports/publisher', { params: data,isV2: true }).then(res=>res.data);
    },
    commissionReportsPublisherAssociate: data => {
        return request.get('associate/commission/reports/publisher', { params: data }).then(res=>res);
    },
    commissionReportsPublisherMetric: data => {
        return request.get('commission/reports/publisher/metric', { params: data,isV2: true }).then(res=>res.data);
    },
    associateCommissionReportsPublisherMetric: data => {
        return request.get('associate/commission/reports/publisher/metric', { params: data }).then(res=>res);
    },
    commissionReportsPublisherDailyMetric: data => {
        return request.get('commission/reports/publisher/daily-metric', { params: data ,isV2: true}).then(res=>res);
    },
    
    associateCommissionReportsPublisherDailyMetric: data => {
        return request.get('associate/commission/reports/publisher/daily-metric', { params: data }).then(res=>res);
    },
    associateCommissionReportsPublisherExport: data => {
        return exportFile(`associate/commission/reports/publisher/export`, data.qs, data.fileName, data.platform);
    },
    commissionReportsPublisherExport: data => {
        return exportFile(`commission/reports/publisher/export`, data.qs, data.fileName, data.platform);
    },
    // Creator Connections publisher
    commissionReportsPublisherCc: data => {
        return request.get('cc/bonus/reports/publisher', { params: data }).then(res=>res.data);
    },
    commissionReportsPublisherMetricCc: data => {
        return request.get('cc/bonus/reports/publisher/metric', { params: data }).then(res=>res.data);
    },
    commissionReportsPublisherDailyMetricCc: data => {
        return request.get('cc/bonus/reports/publisher/daily-metric', { params: data }).then(res=>res);
    },
    commissionReportsPublisherExportCc: data => {
        return exportFile(`cc/bonus/reports/publisher/export`, data.qs, data.fileName, data.platform);
    },
    searchAsin: data => {
        return request.get(`product/asin/search`, { params: data }).then(res=>res);
    },
    getSubmittedDeals: data => {
        return request.get('dm-submitted-deals', { params: data }).then(res=>res);
    },
    getBlacklist: data => {
        return request.get('dm-submitted-deals/brand/blacklist', { params: data }).then(res=>res);
    },
    addBlacklist: data => {
        return request.post('dm-submitted-deals/brand/blacklist', data);
    },
    deleteBlacklist: data => {
        return request.delete(`dm-submitted-deals/brand/blacklist/${data.id}`);
    },
    dmSubmittedDealsExport: data => {
        return exportFile(`dm-submitted-deals/export`, data.qs, data.fileName, data.platform);
    },
    getWhitelist: data => {
        return request.get('dm-submitted-deals/brand/whitelist', { params: data }).then(res=>res);
    },
    addWhitelist: data => {
        return request.post('dm-submitted-deals/brand/whitelist', data);
    },
    deleteWhitelist: data => {
        return request.delete(`dm-submitted-deals/brand/whitelist/${data.id}`);
    },
    dmSubmittedDealsManualAsinSearch: data => {
        return request.get('dm-submitted-deals/manual/asin/search', { params: data }).then(res=>res);
    },
    dmSubmittedDealsManualSubmit: data => {
        return request.post('dm-submitted-deals/manual/submit', data);
    },
    setPublisherTags: data => {
        return request.put(`publisher/details/${data.publisherId}`,data);
    },
    dmSubmittedDealsManualAsinCsvQuery: data => {
        return request.post('dm-submitted-deals/manual/asin/csv/query', data).then(res=>res);
    },
    dmSubmittedDealsManualAsinCrawlerRetry: data => {
        return request.post('dm-submitted-deals/manual/asin/crawler/retry', data);
    },
    dmSubmittedDealsManualAsinCsvExport: data => {
        return exportFile(`dm-submitted-deals/manual/asin/csv/export`, data.qs, data.fileName, data.platform,data.method);
    },
    changePublisherCpc: data => {
        return request.put('publisher/cpc', data);
    },
    changePublisherAssociate: data => {
        return request.put('publisher/associate', data);
    },
    changeClicksTaskStatus: data => {
        return request.put('publisher/clicks-task', data);
    },
}
